import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class RecuperarAccesosGuard implements CanActivate, CanLoad {
  constructor(
      private authService: LoginService,
      private router: Router
    ) { }
  
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.authService.getGeneraAccesos()) {
        return true;
      }
      this.router.navigate(['/']);
      return false;
    }
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      if (this.authService.getGeneraAccesos()) {
        return true;
      }
      this.router.navigate(['/']);
      return false;
    }
}
